// extracted by mini-css-extract-plugin
export var highlightFade = "_2u-4";
export var highlighted = "_2u-3";
export var table = "_2u-1";
export var tableContainer = "_2u-0";
export var totalsRow = "_2u-2";